// Ecosystem
import 'babel-polyfill'; // для поддержки vuetify в ie10+
import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store/index';
import cfg from '@/config';

//Plugins
import axios from 'axios';

// eslint-disable-next-line no-unused-vars
import { createProvider, apolloProvider } from './vue-apollo';
import Vuetify from 'vuetify';
import moment from 'moment';
import MtsUI from '@mts-ui/core';
// eslint-disable-next-line no-unused-vars
import toasters from '@/toasters';

import '@mts-ui/core/src/assets/sprite.svg';
import '@mts-ui/core/dist/mts-ui.core.css';

//Styles
import '@/assets/style/components/typography.styl';
import 'vue2-datepicker/index.css';
import 'material-icons/iconfont/material-icons.scss';
import '@/assets/style/global.styl';
import '@mdi/font/css/materialdesignicons.min.css';
import MTextField from '@/components/MTextField';

import esLocale from 'moment/locale/es';

Vue.config.productionTip = false;
Vue.prototype.$http = axios;
Vue.prototype.$config = cfg;

Vue.use(Vuetify, {
	iconfont: 'md',
	breakpoint: {
		thresholds: {
			md: 1920,
			xl: 2000
		},
		scrollbarWidth: 10
	},
	theme: {
		primary: '#001424',
		buttons: '#e30611',
		secondary: '#29B6F6',
		error: '#f95721',
		greyHeather: '#9198A0',
		deepBlue: '#001424'
	}
});

moment.locale('en', esLocale);

Vue.use(require('vue-moment'), { moment });
Vue.use(MtsUI);
Vue.component('MTextField', MTextField);

new Vue({
	router,
	store,
	apolloProvider: createProvider(),
	render: h => h(App)
}).$mount('#app');
